/**
 * App date component
 */

// React
import React, { FC } from 'react';

// Libraries
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateField, DateFieldProps } from '@mui/x-date-pickers/DateField';
import { Control, Controller } from 'react-hook-form';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

// Material
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Common styles
import { ErrorMessage } from 'styles';

// Utils
import { FORMAT_DATE } from 'utils/constants';

// Styled
const Wrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

const DateFieldContainer = styled(DateField)(
  ({ disabled, error }: { disabled: any; error: boolean }) => ({
    width: '143px',
    height: '32px',
    overflow: 'hidden',
    '& .Mui-disabled': {
      backgroundColor: '#F5F5F5',
      '&:hover fieldset': {
        borderColor: '#b6b6b6 !important',
      },
    },
    '& .MuiOutlinedInput-root': {
      borderColor: !disabled && error ? 'red !important' : '',
      '& fieldset': {
        borderColor: !disabled && error ? 'red !important' : '',
      },
      '&.Mui-focused fieldset': {
        borderColor: !disabled && error ? 'red !important' : '',
      },
    },
  })
);

const inputStyle = {
  height: '32px',
  padding: '8px',
  fontSize: '16px',
  fontWeight: '500',
  color: '#666666',
};

// Interface
interface AppDateProps extends DateFieldProps<any> {
  name: string;
  control: Control<any>;
  disabled?: boolean;
}

// Component
const AppDate: FC<AppDateProps> = ({ name, control, disabled }) => {
  return (
    <Wrapper>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Controller
          name={name}
          control={control}
          render={({ field: { ref, ...restField }, fieldState: { error } }) => {
            return (
              <Box>
                <DateFieldContainer
                  {...restField}
                  inputRef={ref}
                  value={restField.value ? dayjs(restField.value) : null}
                  disabled={disabled}
                  format={FORMAT_DATE}
                  InputProps={{
                    style: inputStyle,
                    placeholder: disabled ? '' : FORMAT_DATE,
                  }}
                  error={!!error}
                />
                <ErrorMessage>{!disabled && error ? error?.message : ''}</ErrorMessage>
              </Box>
            );
          }}
        />
      </LocalizationProvider>
    </Wrapper>
  );
};

export default AppDate;
